module.exports = __webpack_public_path__ + "media/images/facebook_arrow-d2bb7278e6d99d819d2f82faaeec03da.png";